import { Heading, Text, Stack, TextLink } from 'braid-design-system';

export const HeaderMessage = () => (
  <Stack space="large">
    <Heading level="2" component="h1">
      Sell your business online with ease
    </Heading>

    <Stack space="small">
      <Text data={{ testid: 'packages-header-description' }}>
        Wondering how to sell a business online but don&apos;t know where to
        start? The good news is, you&apos;re in the right place. SEEK Business
        is a leading business-for-sale marketplace with thousands of buyers
        browsing our site daily. Whatever your reason for wanting to sell a
        business, our range of advertising packages are designed to showcase
        your business and find the perfect buyer.
      </Text>

      <Text>
        The below advertising packages are for Private Sellers only. If
        you&apos;re a franchisor or broker please{' '}
        <TextLink
          href="https://www.seekbusiness.com.au/contact-us"
          hitArea="large"
        >
          contact us.
        </TextLink>
      </Text>
    </Stack>
  </Stack>
);
